export const onCallToSupportTeam = () => {
	window.open('tel:02192005412');
};

export const scrollToTop = (behavior = 'smooth', position = { top: 0 }) => {
	window.scrollTo({
		...position,
		behavior,
	});
};
